<template>
  <div class="select-container">
    <span class="label">{{ deviceType }}</span>
    <el-select
        class="select"
        v-model="activeDeviceId"
        :placeholder="deviceType"
        @change="handleChange">
      <el-option
          v-for="item in deviceList"
          :key="item.deviceId"
          :label="item.label"
          :value="item.deviceId">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import TRTC from 'trtc-js-sdk';
export default {
  name: "remote_device",
  props: {
    deviceType: {
      type: String,
    },
  },
  data() {
    return {
      deviceList: [],
      activeDevice: {},
      activeDeviceId: '',
    };
  },
  methods: {
    async getDeviceList() {
      switch (this.deviceType) {
        case 'camera':
          this.deviceList = await TRTC.getCameras();
          break;
        case 'microphone':
          this.deviceList = await TRTC.getMicrophones();
          break;
        case 'speaker':
          this.deviceList = await TRTC.getSpeakers();
          break;
        default:
          break;
      }
      [this.activeDevice] = this.deviceList;
      this.activeDeviceId = this.deviceList[0].deviceId;
      this.$emit('change', this.activeDeviceId);
    },
    handleChange() {
      this.$emit('change', this.activeDeviceId);
    },
  },
  mounted() {
    navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(() => {
      this.getDeviceList();
    });
    navigator.mediaDevices.addEventListener('devicechange', this.getDeviceList);
  },
  beforeDestroy() {
    navigator.mediaDevices.removeEventListener('devicechange', this.getDeviceList);
  },
};
</script>

<style scoped>
.select-container {
  display: flex;}
.label {
  display: inline-block;
  padding: 0 20px;
  width: 120px;
  height: 40px;
  text-align: left;
  line-height: 40px;
  border-top: 1px solid #DCDFE6;
  border-left: 1px solid #DCDFE6;
  border-bottom: 1px solid #DCDFE6;
  border-radius: 4px 0 0 4px;
  color: #909399;
  background-color: #F5F7FA;
  font-weight: bold;
}
.select {
  flex-grow: 1;
  border-radius: 0 4px 4px 0 !important;
}
</style>